import { Builder } from '@builder.io/react'
import CdnImage from 'components/util/CdnImage'
// import CloudinaryImage from 'components/util/CloudinaryImage'
import React from 'react'
import './index.css'

interface Props {
  backgroundColor: string
  showImage: boolean
  image: any
  builderImage: any
  imageAltText: string
  showTopRightImage: boolean
  topRightImage: any
  topRightImageAlt: string
  name: string
  headline: string
  text: string
  signature: string
  icon: any
  iconAlt: string
  tag: string
  autoHeight: boolean
  imageHeightRem: string
  imageHeightMobileRem: string
}

const ReviewCard = ({
  backgroundColor,
  showImage,
  image,
  builderImage,
  imageAltText,
  showTopRightImage,
  topRightImage,
  topRightImageAlt,
  name,
  headline,
  text,
  signature,
  icon,
  iconAlt,
  tag,
  autoHeight,
  imageHeightRem,
  imageHeightMobileRem
}: Props) => {
  const getHeight = (height: string) => {
    const addRem = value => (typeof value === 'string' && value.endsWith('rem') ? value : `${value}rem`)
    if (height) {
      return 'h-[' + addRem(height) + '] max-h-[' + addRem(height) + ']'
    }
    return '100%'
  }

  const renderImage = () => {
    return (
      <CdnImage
        className={`index-2 relative w-11/12 mx-auto object-cover ${imageHeightMobileRem ? `${getHeight(imageHeightMobileRem)}` : 'h-[16rem] max-h-[16rem]'}  ${imageHeightRem ? `lg:${getHeight(imageHeightRem)}` : 'lg:h-[22rem] lg:max-h-[22rem]'} rounded-t-3xl mt-6`}
        url={builderImage}
        alt={imageAltText}
        steps={[1080]}
        width={'500'}
      />

      // <>
      //   {builderImage ? (
      //     <CdnImage
      //       className="index-2 relative w-11/12 mx-auto object-cover max-h-[16rem] h-[16rem] lg:max-h-[22rem] lg:h-[22rem] rounded-t-3xl mt-6"
      //       url={builderImage}
      //       alt={imageAltText}
      //       steps={[1080]}
      //       width={'500'}
      //     />
      //   ) : (
      //     <CloudinaryImage
      //       className="index-2 relative w-11/12 mx-auto object-cover max-h-[16rem] h-[16rem] lg:max-h-[22rem] lg:h-[22rem] rounded-t-3xl mt-6"
      //       publicId={image?.public_id}
      //       alt={imageAltText}
      //       loading={'eager'}
      //       steps={[1080]}
      //       width={500}
      //     />
      //   )}
      // </>
    )
  }
  return (
    <>
      {showImage && renderImage()}
      <div
        className={`relative w-11/12 mx-auto p-8 flex flex-col items-start ${autoHeight ? '!h-auto' : ''} ${showImage ? 'rounded-b-3xl h-[24rem] mb-2 lg:mb-6' : 'rounded-3xl my-2 lg:my-6'}`}
        style={{ backgroundColor: backgroundColor }}
      >
        {showTopRightImage && (
          <div className="absolute top-0 right-0 m-8">
            <img className="h-auto w-auto" src={topRightImage} alt={topRightImageAlt} loading="lazy" />
          </div>
        )}
        <div className="flex flex-row justify-start items-center absolute top-0 left-0 m-8">
          {name && (
            <div>
              <p className="font-third font-normal text-3xl lg:text-4xl">{name}</p>
            </div>
          )}
        </div>

        <div className={`${name || showImage ? 'mt-10' : ''} ${!name ? '!mt-0' : ''} flex flex-col w-full`}>
          {headline && (
            <div
              className={`${name ? 'flex justify-start items-start mb-1' : 'mt-6'} ${showTopRightImage ? '' : 'mt-0'}`}
            >
              <p
                className={`enable-list-styles text-sm lg:text-base font-medium font-sans w-full text-left`}
                dangerouslySetInnerHTML={{ __html: headline }}
              ></p>
            </div>
          )}
          {text && (
            <div className="flex justify-start items-start w-full mb-1">
              <p
                className={`enable-list-styles text-xs md:text-sm font-medium font-sans w-full text-left py-2`}
                dangerouslySetInnerHTML={{ __html: text }}
              ></p>
            </div>
          )}
          {signature && (
            <div className="mb-1">
              <p className="font-sans font-bold text-lg">{signature}</p>
            </div>
          )}
          <div className="flex flex-row items-center">
            {icon && <img className="h-auto w-6 pr-2" src={icon} alt={iconAlt} loading="lazy" />}
            {tag && (
              <p
                className={`enable-list-styles text-xs md:text-sm font-medium font-sans w-full text-left`}
                dangerouslySetInnerHTML={{ __html: tag }}
              ></p>
            )}
          </div>
        </div>
      </div>
    </>
  )
}
export default ReviewCard

Builder.registerComponent(ReviewCard, {
  name: 'ReviewCard',
  inputs: [
    {
      name: 'backgroundColor',
      type: 'color',
      defaultValue: '#f9f5f1'
    },
    {
      name: 'showImage',
      type: 'boolean',
      defaultValue: false
    },
    // {
    //   name: 'image',
    //   type: 'cloudinaryImageEditor'
    // },
    {
      name: 'builderImage',
      type: 'file',
      allowedFileTypes: ['jpeg', 'png', 'svg']
    },
    {
      name: 'imageAltText',
      type: 'text',
      defaultValue: ''
    },
    {
      name: 'showTopRightImage',
      type: 'boolean',
      defaultValue: false
    },
    {
      name: 'topRightImage',
      type: 'file',
      allowedFileTypes: ['jpeg', 'png', 'svg']
    },
    {
      name: 'topRightImageAlt',
      type: 'text',
      defaultValue: ''
    },
    {
      name: 'name',
      type: 'text',
      defaultValue: ''
    },
    {
      name: 'headline',
      type: 'richText',
      defaultValue: ''
    },
    {
      name: 'text',
      type: 'richText',
      defaultValue: ''
    },
    {
      name: 'signature',
      type: 'text',
      defaultValue: ''
    },
    {
      name: 'icon',
      type: 'file',
      allowedFileTypes: ['jpeg', 'png', 'svg']
    },
    {
      name: 'iconAlt',
      type: 'text',
      defaultValue: ''
    },
    {
      name: 'tag',
      type: 'richText',
      defaultValue: ''
    },
    {
      name: 'autoHeight',
      type: 'boolean',
      defaultValue: false
    },
    {
      name: 'imageHeightRem',
      type: 'text',
      defaultValue: ''
    },
    {
      name: 'imageHeightMobileRem',
      type: 'text',
      defaultValue: ''
    }
  ]
})
